export enum AuthErrorCodes {
  B2CUserDoesNotExistError = 'AADB2C99002',
  LoginFailure = 'LoginFailure',
  None = 'None',
}
